import React from 'react';
import { clsx } from 'clsx';
import { useInView } from '../../hooks/useInView';

interface SplitFeatureProps {
  children: React.ReactNode;
  /** Right-side visual mock (styled div / placeholder) */
  visual: React.ReactNode;
  /** Swap columns on desktop */
  reverse?: boolean;
  /** Animate visual from left or right */
  visualSlide?: 'left' | 'right';
}

export const SplitFeature: React.FC<SplitFeatureProps> = ({
  children,
  visual,
  reverse = false,
  visualSlide = 'right',
}) => {
  const { ref, inView } = useInView({ threshold: 0.15, triggerOnce: true });

  return (
    <div
      ref={ref}
      className="grid gap-8 lg:gap-12 lg:grid-cols-2 lg:items-center"
    >
      <div className={reverse ? 'lg:order-2' : ''}>{children}</div>
      <div
        className={clsx(
          'min-h-[280px] lg:min-h-[320px] transition-all duration-700 ease-out',
          reverse ? 'lg:order-1' : '',
          visualSlide === 'right' &&
            (inView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'),
          visualSlide === 'left' &&
            (inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-8')
        )}
      >
        {visual}
      </div>
    </div>
  );
}
